import ReactTable from "react-table";
import * as React from "react";
import {PropsWithChildren} from "react";
import {TailSpin} from "react-loader-spinner";
import {SelectTypeString} from "./ReactDropDown";

type Props = {



};
type State = {

}

export default class ReactLoaderSpinner extends React.Component<PropsWithChildren<Props>> {
    constructor(props: Props) {

        super(props);
        this.state = {checked: false};
    }

    render() {
        return (
            <div className="spinner">
                <TailSpin
                    height="80"
                    width="80"
                    color="#4fa94d"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                />

            </div>

        );
    }
}
